var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("span", { staticClass: "pega-break" }, [
    _c("div", { staticClass: "boss-scout-confirm-container" }, [
      _c(
        "div",
        {
          staticClass: "boss-scout-confirm-header",
          attrs: { "data-test": "label-subject" },
        },
        [_vm._v("件名：" + _vm._s(_vm.subject) + "\n    ")]
      ),
      _vm._v(" "),
      _c("div", { staticClass: "boss-scout-confirm-body pega-pre-wrap" }, [
        _c("div", { staticClass: "boss-scout-confirm-contents" }, [
          _c(
            "div",
            { staticClass: "boss-scout-confirm-contents-text clearfix" },
            [
              _c("div", {
                staticClass: "boss-scout-confirm-contents-sentence float-left",
                attrs: { "data-test": "text-body" },
                domProps: { innerHTML: _vm._s(_vm.$sanitize(_vm.renderBody)) },
              }),
            ]
          ),
        ]),
      ]),
      _vm._v(" "),
      _vm.message.files.length
        ? _c(
            "div",
            {
              staticClass: "pega-entry-confirm-footer",
              attrs: { "data-test": "confirm-files" },
            },
            [
              _c("div", { staticClass: "margin-bottom-1" }, [
                _vm._v("\n        添付ファイル\n      "),
              ]),
              _vm._v(" "),
              _vm._l(_vm.message.files, function (file, i) {
                return _c("div", { key: i, staticClass: "position-relative" }, [
                  _c("span", { attrs: { "data-test": "confirm-file-" + i } }, [
                    _vm._v("\n          " + _vm._s(file.name) + "\n        "),
                  ]),
                ])
              }),
            ],
            2
          )
        : _vm._e(),
    ]),
    _vm._v(" "),
    _vm.hasSchedule
      ? _c(
          "div",
          {
            staticClass: "boss-layout-block",
            attrs: { "data-test": "candidate-block" },
          },
          [
            _c("div", { staticClass: "boss-table-2" }, [
              _c("div", { staticClass: "boss-table-2-layout" }, [
                _c(
                  "div",
                  { staticClass: "boss-table-2-item boss-table-2-item-head" },
                  [_vm._v("候補日時")]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass:
                      "boss-table-2-item boss-table-2-item-body boss-table-2-item-body-has-child",
                  },
                  [
                    _c("div", { staticClass: "boss-table-2-layout" }, [
                      _c(
                        "div",
                        {
                          staticClass:
                            "boss-table-2-item boss-table-2-item-head boss-table-2-item-head-compact",
                        },
                        [_vm._v("第一候補")]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass:
                            "boss-table-2-item boss-table-2-item-body js-check-default-cell",
                        },
                        [
                          _c("div", { staticClass: "boss-layout-block" }, [
                            _c(
                              "div",
                              {
                                staticClass:
                                  "boss-layout boss-layout-mobile-wrap boss-layout-start boss-layout-center",
                              },
                              [
                                _c(
                                  "label",
                                  {
                                    attrs: {
                                      "data-test": "label-candidate-date-1",
                                    },
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        _vm._f("parseDate")(
                                          _vm.candidateDate(0)
                                        )
                                      )
                                    ),
                                  ]
                                ),
                              ]
                            ),
                          ]),
                        ]
                      ),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "boss-table-2-layout" }, [
                      _vm._m(0),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass:
                            "boss-table-2-item boss-table-2-item-body js-check-default-cell",
                        },
                        [
                          _c("div", [
                            _c("div", { staticClass: "boss-layout-block" }, [
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "boss-layout boss-layout-mobile-wrap boss-layout-start boss-layout-center",
                                },
                                [
                                  _c(
                                    "label",
                                    {
                                      attrs: {
                                        "data-test": "label-candidate-date-2",
                                      },
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm._f("parseDate")(
                                            _vm.candidateDate(1)
                                          )
                                        )
                                      ),
                                    ]
                                  ),
                                ]
                              ),
                            ]),
                          ]),
                        ]
                      ),
                    ]),
                  ]
                ),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "boss-table-2-layout" }, [
                _c(
                  "div",
                  { staticClass: "boss-table-2-item boss-table-2-item-head" },
                  [_vm._v("所要時間")]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "boss-table-2-item boss-table-2-item-body" },
                  [
                    _c("label", { attrs: { "data-test": "label-duration" } }, [
                      _vm._v(_vm._s(_vm._f("parseDuration")(_vm.duration))),
                    ]),
                  ]
                ),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "boss-table-2-layout" }, [
                _c(
                  "div",
                  { staticClass: "boss-table-2-item boss-table-2-item-head" },
                  [_vm._v("場所（任意）")]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "boss-table-2-item boss-table-2-item-body" },
                  [
                    _c("label", { attrs: { "data-test": "label-place" } }, [
                      _vm._v(_vm._s(_vm.place) + "\n          "),
                    ]),
                  ]
                ),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "boss-table-2-layout" }, [
                _vm._m(1),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass:
                      "boss-table-2-item boss-table-2-item-body width-100",
                  },
                  [
                    _c("div", [
                      _c(
                        "div",
                        {
                          staticClass:
                            "boss-layout boss-layout-start boss-layout-gap-large boss-layout-wrap",
                        },
                        [
                          _c(
                            "label",
                            { attrs: { "data-test": "text-contents" } },
                            [_vm._v(_vm._s(_vm.interviewContents))]
                          ),
                        ]
                      ),
                    ]),
                  ]
                ),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "boss-table-2-layout" }, [
                _c(
                  "div",
                  { staticClass: "boss-table-2-item boss-table-2-item-head" },
                  [_vm._v("備考（任意）")]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass:
                      "boss-table-2-item boss-table-2-item-body pega-pre-wrap",
                  },
                  [
                    _c("label", { attrs: { "data-test": "text-remarks" } }, [
                      _vm._v(_vm._s(_vm.remarks)),
                    ]),
                  ]
                ),
              ]),
            ]),
          ]
        )
      : _vm._e(),
    _vm._v(" "),
    _c("div", { staticClass: "boss-layout-block" }, [
      _c("div", { staticClass: "boss-table-wrap" }, [
        _c("div", { staticClass: "boss-table-2" }, [
          _c(
            "div",
            { staticClass: "boss-table-2-layout boss-table-2-layout-half" },
            [
              _c("div", { staticClass: "boss-table-2-layout" }, [
                _c(
                  "div",
                  { staticClass: "boss-table-2-item boss-table-2-item-head" },
                  [_vm._v("選考フェーズ")]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "boss-table-2-item boss-table-2-item-body" },
                  [
                    _c("label", { attrs: { "data-test": "label-phase" } }, [
                      _vm._v(_vm._s(_vm.phase)),
                    ]),
                  ]
                ),
              ]),
            ]
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "boss-table-2-layout boss-table-2-layout-half" },
            [
              _c("div", { staticClass: "boss-table-2-layout" }, [
                _c(
                  "div",
                  { staticClass: "boss-table-2-item boss-table-2-item-head" },
                  [_vm._v("選考ステータス")]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "boss-table-2-item boss-table-2-item-body" },
                  [
                    _c("label", { attrs: { "data-test": "label-status" } }, [
                      _vm._v(_vm._s(_vm.status)),
                    ]),
                  ]
                ),
              ]),
            ]
          ),
        ]),
      ]),
    ]),
    _vm._v(" "),
    _vm._m(2),
    _vm._v(" "),
    _c(
      "div",
      {
        staticClass:
          "boss-button-container boss-button-container-entry-message",
      },
      [
        _c("div", { staticClass: "pega-entry-message-button" }, [
          _c("div", { staticClass: "pega-entry-message-button-return-area" }, [
            _c(
              "button",
              {
                staticClass: "boss-button boss-button-return",
                attrs: { type: "button", "data-test": "button-back" },
                on: {
                  click: function ($event) {
                    return _vm.$emit("back")
                  },
                },
              },
              [
                _c("span", { staticClass: "boss-button-return-text" }, [
                  _vm._v("戻る"),
                ]),
              ]
            ),
          ]),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "pega-entry-message-button" }, [
          _c(
            "button",
            {
              staticClass: "boss-button-center boss-button-confirm",
              attrs: { type: "button", "data-test": "button-submit" },
              on: { click: _vm.onSubmit },
            },
            [
              _c("span", { staticClass: "boss-button-confirm-text" }, [
                _vm._v("この内容で送信する"),
              ]),
            ]
          ),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "pega-entry-message-button" }, [
          _c(
            "button",
            {
              staticClass: "boss-button-center boss-button-confirm",
              attrs: { type: "button", "data-test": "button-reserve" },
              on: { click: _vm.onReserve },
            },
            [
              _c("span", { staticClass: "boss-button-confirm-text" }, [
                _vm._v("送信予約する"),
              ]),
            ]
          ),
          _c("br"),
          _vm._v(" "),
          _c(
            "span",
            {
              staticClass:
                "boss-annotation-text pega-entry-message-reservation-reserved-annotation",
            },
            [_vm._v("※土日を除き、翌日の10時から順次送信されます。")]
          ),
        ]),
      ]
    ),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      {
        staticClass:
          "boss-table-2-item boss-table-2-item-head boss-table-2-item-head-compact",
      },
      [
        _vm._v("\n              第二候補\n              "),
        _c("br"),
        _vm._v("（任意）\n            "),
      ]
    )
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      { staticClass: "boss-table-2-item boss-table-2-item-head" },
      [
        _vm._v("\n          内容（複数選択可能）\n          "),
        _c("br"),
        _vm._v("（任意）\n        "),
      ]
    )
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "boss-layout-block" }, [
      _c("p", { staticClass: "boss-text" }, [
        _vm._v(
          "\n      ※「選考フェーズ、選考ステータス」は応募者側では表示されません。\n    "
        ),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }